var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 73,
    stroke: "#C2D9FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 56C94.5 54.6193 93.3807 53.5 92 53.5L69.5 53.5C68.1193 53.5 67 54.6193 67 56C67 57.3807 68.1193 58.5 69.5 58.5H89.5V78.5C89.5 79.8807 90.6193 81 92 81C93.3807 81 94.5 79.8807 94.5 78.5L94.5 56ZM57.7678 93.7678L93.7678 57.7678L90.2322 54.2322L54.2322 90.2322L57.7678 93.7678Z",
    fill: "#C2D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircled);
export default __webpack_public_path__ + "static/media/arrow-circled.becba377ba4ee20db6ce2fae9a05d4f1.svg";
export { ForwardRef as ReactComponent };